<template>
  <v-container class="mt-16">
    <v-row class="mt-10">
      <v-col md="6" lg="4" offset-md="3" offset-lg="4">
        <v-card>
          <v-card-title class="headline">{{ $t('resetPassword.title') }}</v-card-title>

          <v-card-text>
            <v-text-field
              v-if="!showSuccess"
              v-model="password"
              :hint="$t('resetPassword.passwordHint')"
              type="password"
              :label="$t('resetPassword.password')"
            ></v-text-field>

            <p class="text-error" v-if="showError">{{ $t('common.error') }}</p>
            <p class="text-success" v-if="showSuccess">{{ $t('resetPassword.passwordChangedMessage') }}</p>
          </v-card-text>

          <v-card-actions class="pr-4 pb-3">
            <v-spacer></v-spacer>

            <v-btn v-if="!showSuccess" text :disabled="running" @click="cancel()"> {{ $t('common.cancel') }} </v-btn>

            <v-btn
              v-if="!showSuccess"
              color="primary"
              class="black--text"
              @click="resetPassword()"
              :disabled="!validatePassword() || running"
              :loading="running"
            >
            {{ $t('common.save') }}
            </v-btn>

            <v-btn v-if="showSuccess" color="primary" class="black--text" @click="cancel()"> {{ $t('common.close') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UserService } from '../../services/user.service';
export default {
  props: {
    resetpasswordkey: '',
  },

  data() {
    return {
      showSuccess: false,
      showError: false,
      running: false,
      password: '',
    };
  },

  methods: {
    validatePassword() {
      return this.password && this.password.length >= 6;
    },

    resetPassword() {
      this.showError = false;
      this.running = true;

      new UserService()
        .resetPassword({ password: this.password, pwdkey: this.resetpasswordkey })
        .then(() => {
          this.showSuccess = true;
          this.clearFields();
        })
        .catch(() => {
          this.showError = true;
          this.running = false;
        });
    },

    cancel() {
      this.$router.replace('/');
    },

    clearFields() {
      this.password = '';
      this.running = false;
    },
  },
};
</script>
